import { useRef as u, useEffect as n } from "react";
function f(e, t) {
  const r = u(null);
  n(() => {
    r.current !== null && t(r.current, e), r.current = e;
  }, [e]);
}
export {
  f as useStateWatcher
};
